import { USER_GLB } from "../types";

export default function glb(state = {}, action = {}) {
  switch (action.type) {
    case USER_GLB: {
      return action.glb;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/glb.js